import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.netural100};
  margin-top: 4rem;
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 2px 0px rgba(24, 30, 45, 0.05),
    0px 0px 10px 0px rgba(64, 56, 95, 0.05),
    0px 0px 40px 0px rgba(81, 94, 108, 0.05);
  border-radius: 8px;
  padding: 40px;
  max-width: 636px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    padding: 20px;
  }
`;

export const Title = styled.h2`
  font-family: "Archivo", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 34px;
  color: ${({ theme }) => theme.colors.primary600};
  text-align: center;
  margin-bottom: 16px;
`;

export const Description = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.netural800};
  text-align: center;
  margin-bottom: 16px;
`;

export const EmailBox = styled.div`
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.netural800};
  margin-top: 38px;
  margin-bottom: 4px;
  text-align: center;
`;

export const NextButton = styled.button``;

export const IconBox = styled.div`
  margin-bottom: 24px;
  svg {
    width: 75px;
    height: 75px;
  }
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  width: 360px;
  max-width: 100%;
  margin-top: 56px;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    width: 100%;
    max-width: 360px;
  }
`;

export const SecondDescription = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.netural600};
  text-align: center;
  margin-bottom: 16px;
`;

export const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 40px;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    flex-wrap: wrap;
  }
`;

export const InfoBox = styled.div`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.netural300};
  border-radius: 8px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 523px;
  width: 100%;
  min-width: 350px;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    max-width: unset;
    min-width: unset;
  }
`;

export const InfoTitle = styled.h3`
  font-family: "Archivo", sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.primary600};
  text-align: center;
  margin: 24px 0 8px 0;
`;

export const InfoDescription = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 15px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.netural800};
  text-align: center;
  margin-bottom: 64px;
`;
